import {System} from './System'

export const Crew = {

    getRoleItems() {
        return [
            {label: "Arbeiter",         value:'worker'},
            {label: "Bauführer",        value:'foreman'},
            {label: "Büro",             value:'office'},
            {label: "Administrator",    value:'admin'},
            {label: "Operator",         value:'operator'},
            {label: "Subunternehmer",   value:'contractor'}
        ]
    },

    getRoleLabel(role) {
        const item = this.getRoleItems().find(r => r.value === role);
        return item ? item.label : role;
    },

    getRoleSelection(userRole, naLabel = " ") {
        const roleInclusions = {
            operator: ["worker", "foreman", "office", "admin", "operator"],
            admin   : ["worker", "foreman", "office", "admin"],
            office  : ["worker", "foreman", "office"],
            foreman : ["worker", "foreman"],
            worker  : ["worker"]
        };

        const allowedRoles = roleInclusions[userRole] || Crew.getRoleItems().map(role => role.value);
        const filteredRoles = Crew.getRoleItems().filter(role => allowedRoles.includes(role.value));

        return [{label: naLabel, value: -1}, ...filteredRoles];
    },


    getRolesBySelection(roleSelection) {
        return roleSelection === -1 ? ["worker", "foreman", "office", "admin", "operator"] : [roleSelection];
    },


    /**
     * Get crew label for the given type ['crew','contractor'].
     */
    getLabel(type) {
        const labelMap = {
            crew: "Mitarbeiter",
            contractor: "Subunternehmer"
        }
        return labelMap[type];
    },


    /**
     * Get list comlumns for the given type ['crew','contractor'].
     */
    getListColumns(type, includeSystemColumns = false) {

        const fieldMap = {
            crew        : [ 'role', 'initials', 'lastname', 'firstname', 'skills', 'address', 'zip', 'city',
                'phone', 'private_phone', 'email', 'login_enabled', 'login_name', 'active', 'id' ],
            contractor  : [ 'company', 'skills', 'address', 'zip', 'city', 'phone', 'email', 'active', 'id' ]
        };

        const fields = fieldMap[type];

        const roleMap = Object.fromEntries(Crew.getRoleItems().map(item => [item.value, item.label]));

        const allColumns = [
            { field: 'role',            headerName: 'Rolle',        type: 'string',  width: 120, sortable: true, renderCell: (params) => roleMap[params.value] || params.value },
            { field: 'company',         headerName: 'Firma',        type: 'string',  width: 240, sortable: true },
            { field: 'initials',        headerName: 'Initialen',    type: 'string',  width:  60, sortable: true },
            { field: 'lastname',        headerName: 'Nachname',     type: 'string',  width: 120, sortable: true },
            { field: 'firstname',       headerName: 'Vorname',      type: 'string',  width: 120, sortable: true },
            { field: 'skills',          headerName: 'Funktion',     type: 'string',  width: 120, sortable: true },
            { field: 'address',         headerName: 'Adresse',      type: 'string',  width: 200, sortable: true },
            { field: 'zip',             headerName: 'PLZ',          type: 'string',  width: 100, sortable: true },
            { field: 'city',            headerName: 'Ort',          type: 'string',  width: 120, sortable: true },
            { field: 'phone',           headerName: 'Telefon',      type: 'string',  width: 120, sortable: true },
            { field: 'private_phone',   headerName: 'Tel. Privat',  type: 'string',  width: 120, sortable: true },
            { field: 'email',           headerName: 'E-Mail',       type: 'string',  width: 240, sortable: true },
            { field: 'login_enabled',   headerName: 'Login',        type: 'number',  width:  60, sortable: true, renderCell: (params) => (params.value ? 'Ja' : 'Nein') },
            { field: 'login_name',      headerName: 'Login Name',   type: 'string',  width: 120, sortable: true },
            { field: 'active',          headerName: 'Aktiv',        type: 'number',  width:  50, sortable: true, renderCell: (params) => (params.value ? 'Ja' : 'Nein') },
            { field: 'id',              headerName: 'Id',           type: 'number',  width:  50, sortable: true }
        ];


        const columns = allColumns.filter(col => fields.includes(col.field))

        // Include system columns if requested
        if (includeSystemColumns) {
            columns.push(...System.getSystemColumns());
        }

        return columns;
    },


    getFormValues(type) {
        return {
            "id"                : null,
            "role"              : type === 'contractor' ? 'contractor' : -1,
            "active"            : 1,
            "company"           : "",
            "initials"          : "",
            "firstname"         : "",
            "lastname"          : "",
            "address"           : "",
            "zip"               : "",
            "city"              : "",
            "country"           : "",
            "email"             : "",
            "phone"             : "",
            "private_phone"     : "",
            "skills"            : "",
            "login_enabled"     : 0,
            "login_reset_pw"    : 0,
            "login_name"        : "",
            "login_pw"          : "",
            "version"           : 0,
            "insert_ts"         : "",
            "insert_by"         : "",
            "update_ts"         : "",
            "update_by"         : ""
        }
    },

    getFormErrors() {
        return System.initializeFormErrors(this.getFormValues());
    },

    getFormRequiredFields(type) {
        if (type === "contractor") {
            return [
                "company"
            ]
        }

        return [
            "role",
            "firstname",
            "lastname",
        ];
    },


    mapDbToForm(dbValues) {
        const values = { ...dbValues };

        values.login_reset_pw = 0;      // always set to 0 (update will only occur if changed to 1)
        values.login_pw = "";           // always add login_pw to fields and reset to empty string

        return values;
    },

    mapFormToDb(formValues) {
        const mappedValues = {
            id              : formValues.id,
            role            : System.mapCodeToDb(formValues.role),
            active          : formValues.active,
            company         : System.mapValueToDb(formValues.company),
            initials        : System.mapValueToDb(formValues.initials),
            firstname       : System.mapValueToDb(formValues.firstname),
            lastname        : System.mapValueToDb(formValues.lastname),
            address         : System.mapValueToDb(formValues.address),
            zip             : System.mapValueToDb(formValues.zip),
            city            : System.mapValueToDb(formValues.city),
            country         : System.mapValueToDb(formValues.country),
            email           : System.mapValueToDb(formValues.email),
            phone           : System.mapValueToDb(formValues.phone),
            private_phone   : System.mapValueToDb(formValues.private_phone),
            skills          : System.mapValueToDb(formValues.skills),
            login_enabled   : formValues.login_enabled,
            login_reset_pw  : formValues.login_reset_pw,
            login_name      : System.mapValueToDb(formValues.login_name),
            login_pw        : System.mapValueToDb(formValues.login_pw),
            version         : formValues.version
        }
        if (formValues.login_reset_pw === 0) {
            delete mappedValues.login_reset_pw;
            delete mappedValues.login_pw;
        }
        return mappedValues;
    },

    // ----------------------------------------------------------------------------------------------------------------
    // Authorization (login an password) handling
    // ----------------------------------------------------------------------------------------------------------------

    generateLoginName(firstname, lastname) {

        // check for valid values
        if (!firstname.trim() || !lastname.trim()) {
            return "";
        }

        // init mapping table and normalize function
        const specialCharMap = {
            'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss',
            'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
            'á': 'a', 'à': 'a', 'â': 'a', 'å': 'a',
            'ó': 'o', 'ò': 'o', 'ô': 'o', 'ø': 'o',
            'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
            'ú': 'u', 'ù': 'u', 'û': 'u',
            'ý': 'y', 'ÿ': 'y',
            'ñ': 'n', 'ç': 'c'
        };

        const normalize = (str) => {
            return str.toLowerCase().replace(/[äöüßéèêëáàâåóòôøíìîïúùûýÿñç]/g,
                match => specialCharMap[match] || match );
        }

        // normalize and return login name
        const firstToken = firstname.split(' ')[0];
        const lastToken = lastname.split(' ')[0];

        return `${normalize(firstToken)}.${normalize(lastToken)}`;
    },

    getLoginFormValues() {
        return { "login_name": "", "login_pw": "" }
    },

    getLoginFormErrors() {
        return System.initializeFormErrors(this.getFormValues());
    },

    getLoginFormRequiredFields(type) {
        return [ "login_name", "login_pw" ];
    },

    getPwChangeFormValues() {
        return { "login_pw": "", "login_pw2" : ""
        }
    },

    getPwChangeFormErrors() {
        return System.initializeFormErrors(this.getFormValues());
    },

    getPwChangeFormRequiredFields(type) {
        return [ "login_pw", "login_pw2" ];
    }

};